import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ITermsAndConditionsDialogComponent } from '@app/shared/models/dialog/terms-and-conditions-dialog';

@Component({
  selector: 'app-terms-and-conditions-dialog',
  templateUrl: './terms-and-conditions-dialog.component.html',
  styleUrls: ['./terms-and-conditions-dialog.component.scss'],
})
export class TermsAndConditionsDialogComponent {
  public title: string = '';
  public description: string = '';
  public terms: string = '';
  public confirmText: string = '';

  public hasAccepted: boolean = false;

  constructor(private dialogRef: MatDialogRef<TermsAndConditionsDialogComponent>, @Inject(MAT_DIALOG_DATA) private data: ITermsAndConditionsDialogComponent) {
    this.title = this.data.title;
    this.description = this.data.description;
    this.terms = this.data.terms;
    this.confirmText = this.data.confirmText;
  }

  public cancel(): void {
    this.dialogRef.close(false);
  }

  public acceptTerms(): void {
    this.dialogRef.close(true);
  }
}
